export default __webpack_public_path__ + "static/media/max-temp.d6c2f0cd.png";